import http from "../../http-common";

class service {

  url = "/anagrafica/menu";

  getAll() {
    return http.get(this.url);
  }

  get(id, params = {}) {
    return http.get(this.url + '/' + id, { params });
  }

  search(params) {
    return http.get(this.url + '/search', { params });
  }

  autocomplete(params) {
    return http.get(this.url + '/autocomplete', { params });
  }

  fullmenu(params = {}) {
    params.expand = 'vociPermesse';
    return http.get(this.url + '/fullmenu', { params });
  }
}

export default new service();